/*
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Visionnement du slideshow
 */
/* global lib, Visibility, bowser */

(function($g, $, createjs) {
    "use strict";

    var BASE_CTRL_WIDTH = 960;
    var BASE_CTRL_HEIGHT = 30;

    var Ticker = createjs.Ticker;
    var Shape = createjs.Shape;
    var Text = createjs.Text;
    var Stage = createjs.Stage;
    var Container = createjs.Container;
    var Mod = Modernizr;
    var Slideshow = $g.Slideshow;
    var ScaledContainer = $g.ScaledContainer;
    var PlayControls = $g.PlayControls;
    var MusicPlayer = $g.MusicPlayer;
    var VideoPlayer = $g.VideoPlayer;
    var ImageLoader = $g.ImageLoader;
    var BtnsActions = $g.BtnsActions;

    var OK = 5;
    var UNKNOW = 3;
    var OLD = 2;

    var PLAYING = Slideshow.STATES.PLAYING;

    var slideshow;
    var controles;
    var stage;
    var controlsStage;
    var controlesScaling;
    var mPlayer;
    var vPlayer;
    var otime;
    var isFullscreen = null;
    var visCallBackId;

    /**
     * Check if this is a supported browser
     * yes, no, unknown
     */
    function supported() {
        var b = bowser;
        var mobile = b.tablet || b.mobile;
        var support = (mobile) ? {
            ios: 10,
            chrome: 36,
            firefox: 30,
            opera: 27, //unofficial support
            android: 5

        } : {
            msie: 11,
            firefox: 29,
            chrome: 20,
            safari: 7,
            opera: 12
        };

        var version = b.version;
        for (var nav in support) {
            if (b[nav]) {
                if (nav === "android") {//unknown browser detech with os version
                    version = b.osversion;
                }
                if (version) {
                var have = version.split(".");
                var need = support[nav].toString().split(".");
                for (var i = 0; i < need.length; i++) {
                    var hi = have[i] | 0;
                    var ni = need[i] | 0;
                    if (ni > hi) {
                        return OLD;
                    } else if (ni < hi) {
                        break;
                    }
                }
                }
                return OK;
            }
        }
        return UNKNOW;
    }

    function browserWarning(support) {
        var msgs = [];
        msgs[OLD] = "Votre navigateur n'est pas suffisemment récent, l'activité pourrait ne pas fonctionner correctement.";
        var m = msgs[support];
        if (m) {
            var c = Cookie.get("bwarning");
            if (!c) {
                setTimeout(function () {
                    var $warning = $("<div><p>" + m + "</p><p>Nous vous recommendons fortement de mettre votre appareil à jour</p><a href='browser.html'>En savoir plus</a> | <a class='jouer'>Jouer quand même</a></div>");
                    $warning.find(".jouer").click(function () {
                        $warning.remove();
                        Cookie.write("bwarning", "1");
                    });
                    $("body").prepend($warning);
                }, 100);
            }
        }
    }

    function updateVis() {
        var cfg = $g.cfg;
        var hidden = Visibility.hidden();
        if (hidden) {
            Ticker.framerate = 0;
        } else {
            Ticker.framerate = cfg.fps;
        }
        /*var soundPlayer = $g.soundPlayer;
        if (soundPlayer) {
            soundPlayer.setMuted(hidden);
        }*/
    }

    /**
     * Check for visibility, ajust settings
     * @returns
     */
    function setupVisibility() {
        visCallBackId = Visibility.change(function () {
            updateVis();
        });
        updateVis();
    }

    function setupFps() {
        var efps = new Text("0", "12px Arial", "#000000");
        efps.x = 5;
        efps.y = 5;
        var graphics = new createjs.Graphics().beginFill("#ffffff").drawRect(2, 2, 150, 14);
        var fond = new Shape(graphics);
        var stageTick = 0;
        stage.addChild(fond);
        stage.addChild(efps);
        setInterval(function () {
            var delta = Ticker.getMeasuredFPS();
            var tickTime = Ticker.getMeasuredTickTime();
            efps.text = delta.toFixed(2) + "  sp:" + stageTick.toFixed(2) + "  ms:" + tickTime.toFixed(2);
            stageTick = 0;
            var n = stage.numChildren;
            stage.setChildIndex(efps, n-1);
            stage.setChildIndex(fond, n-2);
        }, 1000);
        stage.addEventListener("tick", function () {
            stageTick++;
        });

    }

    function setFullscreen(fullscreen) {
        var $slideshow = $("#slideshow");
        var $controls = $("#controls");
        if (fullscreen!==isFullscreen) {
            isFullscreen=fullscreen;
            if (fullscreen) {
                $slideshow.addClass("fullscreen");
                $("#slideshowcontainer").addClass("fullscreen");
                $("footer").hide();
                $controls.hide();
                stage.addChild(controles);
                controlsStage.enableMouseOver(0);
                stage.enableMouseOver(10);
                controles.centerBtn.visible = true;
            } else {
                $("#slideshowcontainer").removeClass("fullscreen");
                $slideshow.removeClass("fullscreen");
                $("footer").show();
                $controls.show();
                controlsStage.addChild(controles);
                stage.enableMouseOver(0);
                controlsStage.enableMouseOver(10);
                controles.centerBtn.visible = false;
                //var width = 1280;
                //var height = 720;

            }
        }
    }

    function fixContainer() {
        var cfg = $g.cfg;
        var $container = $("#page-inner .p-wrap");
        if ($container.length == 0) {
            $container = $("#slideshowcontainer").parent();
        }
        var pageHeight = window.innerHeight;
        var containerHeight = $container.height();
        var containerMargin = parseInt($container.css("marginTop"))|0;
        var bodyHeight = $("body").height();
        var ajust = bodyHeight - containerHeight + containerMargin;
        var height = pageHeight-ajust;
        $container.height(height);
        return [containerHeight, pageHeight < cfg.innerControlsAtHeight];
    }

    function loop() {
        var fr = fixContainer();
        var fullscreenElement = fr[1];
        var containerHeight = fr[0]|0;
        var cfg = $g.cfg;
        var $slideshow = $("#slideshow");
        var $controls = $("#controls");
        var canvas = stage.canvas;
        var ratio = window.devicePixelRatio || 1;

        var fullscreenElement = fullscreenElement || document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
        controles.autohide = fullscreenElement;
        setFullscreen(fullscreenElement?true:false);
        var controlHeight = $controls.height()|0;
        var slideShowHeight = fullscreenElement?(containerHeight):(containerHeight-controlHeight-5);
        $slideshow.height(slideShowHeight);
        var width = ($slideshow.width()|0)*ratio;
        var height = slideShowHeight*ratio;

        if (width>32&&height>32) {
            if (canvas.width!==width||canvas.height!==height) {
                canvas.width=width;
                canvas.height=height;
                //resize.trigger(canvas);
                slideshow.resize();
                //var size = $g.computeScaling(width, height, cfg.width, cfg.height, cfg.minScale*ratio);
                //controlesScaling.update(size);
            }
        }

        var twidth = cfg.width;
        var theight = cfg.height;
        if (!fullscreenElement) {
            width = ($controls.width()|0)*ratio;
            height = ($controls.height()|0)*ratio;
            twidth = BASE_CTRL_WIDTH;
            theight = BASE_CTRL_HEIGHT;
        }
        if (width>32&&height>32) {
            canvas = controlsStage.canvas;
            if (controlesScaling.realWidth!==width||controlesScaling.realHeight!==height) {
                canvas.width=width;
                canvas.height=height;
                var size = $g.computeScaling(width, height, twidth, theight, cfg.minScale*ratio);
                controlesScaling.update(size);
            }
        }

        var running = slideshow.etat===PLAYING && slideshow.ready && !slideshow.dragging;
        if (running) {
            var time = Ticker.getTime(true) | 0;
            if (otime) {
                var delta = time - otime;
                slideshow.advance(delta);
            }
            otime = time;
            if (slideshow.haveAudio) {
                //Current slide have audio, disable current music
                mPlayer.stop();
            } else {
                mPlayer.play();
            }
        } else {
            otime = null;
            mPlayer.stop();
            slideshow.stillFrame();
        }

        if (vPlayer) {
            vPlayer.playing = running;
            vPlayer.muted = mPlayer.muted || !slideshow.haveAudio;
        }

        controles.update();
        stage.update();
        if (!fullscreenElement) {
            controlsStage.update();
        }
    }

    function startTicker() {
        var cfg = $g.cfg;
        Ticker.framerate = cfg.fps;
        Ticker.timingMode = Ticker.RAF;
        Ticker.addEventListener("tick", loop);
        createjs.Touch.enable(stage);
        createjs.Touch.enable(controlsStage);
        if (cfg.showFps) {
            setupFps();
        }

        setupVisibility();
    }

    /**
     * Charge la musique d'avance si possible
     * @param {function} complete
     * @returns {undefined}
     */
    function prepareMusic(complete) {
        var cfg = $g.cfg;
        var audio = null;
        try {
            audio = parent.window.readyAudio;
        } catch (e) {
            //Cross window, catch and dont care
        }
        mPlayer = new MusicPlayer(audio || new Audio(), new Audio(), cfg.musics);
        if (!audio && cfg.musics && cfg.musics.length) {
            mPlayer.init(complete);  
        } else {
            mPlayer.init();  
            complete();//préparation de la musique terminé
        }
    }

    /**
     * Préparation du vidéo player si nécessaire
     */
    function prepareVideo(complete) {
        var firstVideo = slideshow.videos[0];
        if (firstVideo) {
            var video = null;
            try {
                video = parent.window.readyVideo;
            } catch (e) {
                //Cross window, catch and dont care
            }
            vPlayer = new VideoPlayer(video);
            vPlayer.init(complete);
            slideshow.vPlayer = vPlayer;
        } else {
            complete();//préparation du vidéo terminé
        }
    }

    /**
     * Setup the slideshow
     * @param {function} complete
     * @returns {undefined}
     */
    function prepareSlideshow(complete) {
        var main = stage.main;
        var imgLoader = new ImageLoader();

        slideshow = new Slideshow(server, imgLoader, stage, main,{loop:true}, "/");

        slideshow.setData($g.data, function() {
            complete();
        });
        stage.tick();
    }

    function setupKeyboard() {
        var canvas = stage.canvas;
        $(canvas).on("keypress", function(event) {
			//$g.log(event);
            switch (event.key) {
                case "ArrowRight":
                    slideshow.next();
                    return false;
                    break;
                case "ArrowLeft":
                    slideshow.prev();
                    return false;
                    break;
            }
        });
        $(canvas).on("mousedown", function() {
            canvas.focus();
        });
    }

    function videoOk() {
        controles.visible = true;
        setTimeout(function() {
            slideshow.start(function() {
                setupKeyboard();
            });
        },5);
    }

    function waitForClickPlay() {
        $(".wrapslideshow").append(
            "<img class='bigplay' src='/img/fragment/icn-play.svg' style='z-index: 1; position: absolute; top: 50%; left: 50%; height: 80%; transform: translate(-50%, -50%); cursor: pointer;' />"
        );

        //var canvas = stage.canvas;
        $(document.body).on("click touchstart", function() {
            $(".bigplay").remove();
            $(this).off("touchstart");
            $(this).off("click");
            if (vPlayer) {
                vPlayer.clicked();
            }
            mPlayer.clicked();
            videoOk();
        });
    }

    /**
     * everithing ready, start up !
     * @returns {undefined}
     */
    function start() {
        var cfg = $g.cfg;
        var showPlayButton = cfg.showPlayButton || $g.data.showPlayButton;
        PlayControls.call(controles, slideshow, mPlayer);
        BtnsActions.call(controles, slideshow, mPlayer, stage);
        
        controlsStage.tick();
        startTicker();
        if (vPlayer && vPlayer.requireClick()) {
            //Possibilité d'exception ici, il semblerais qu'on accès à slideshow avant son init
            waitForClickPlay();
        } else if (cfg.musics && cfg.musics.length>0 && mPlayer.muted && showPlayButton) {
            waitForClickPlay();
        } else {
            videoOk();
        }
    }

    /**
     * Destroy everithing as best as we could
     * @returns {undefined}
     */
    function destroy() {
        if (mPlayer) {
            mPlayer.destroy();
        }
        if (vPlayer) {
            vPlayer.destroy();
        }
        Ticker.reset();
        if (slideshow) {
            slideshow.destroy();
        }
        Visibility.unbind(visCallBackId);
    }

    $g.destroy = destroy;

    /**
     * Détection & initialisation
     * Attention, jQuery pourrait ne pas être présent
     */
    $g.init = function (cfg) {
        try {
            var support = supported();
            if ($ && Mod.canvas && Mod.audio && Mod.canvastext && Object.defineProperty) {
                browserWarning(support);
                //$(window).on("beforeunload", destroy);

                //config
                $.extend($g.cfg, $g.cfg[cfg.env], cfg);
                cfg = $g.cfg;

                //graphics
                stage = new Stage("slideshow");
                stage.tickOnUpdate = false;

                var main = new Container();
                stage.addChild(main);

                stage.main = main;

                controlsStage = new Stage("controls");
                controlsStage.tickOnUpdate = false;
                controles = new lib.video_player_m();
                controlesScaling = new ScaledContainer(controles);
                controles.size=controlesScaling;
                controles.visible = false;
                stage.addChild(controles);

                $("#info").empty();

                $g.paral(
                    prepareMusic,
                    prepareSlideshow,
                    prepareVideo,
                    start
                );
            } else {

                setTimeout(function () {

                    $("#info").html("<p>Navigateur non compatible, envisagez une mise à jour</p>");

                }, 100);

            }

        } catch (error) {
            $g.exception(error);
        }
    };

    if ($g.data) {
        $g.init($g.data);
    }
})(PVPGEngine, jQuery, createjs);
